// import { useState } from 'react';
// import yaml from 'js-yaml';
// import UserStory from './UserStory'

// export function YamlEditor ({ value, onChanged }) {
//   const parse = (text) => {
//     try {
//       return yaml.load(text);
//     } catch (e) {
//       console.error(e);
//     }
//   };

//   const [formYaml, setFormYaml] = useState(value);
//   const [parsedJson, setParsedJson] = useState(parse(value));

//   const textareaOnChanged = (e) => {
//     setFormYaml(e.target.value);
//     const parsed = parse(e.target.value);
//     if (parsed) {
//       const normalized = UserStory.normalize(parsed.data, parsed.settings);
//       // const transformed = transformJson(parsed.data);
//       // const normalized = normalizeData(transformed);
//       onChanged(normalized, parsed.settings);
//       setParsedJson(normalized);
//       // onChanged(transformed, parsed.settings);
//       // setParsedJson(transformed);

//       // onChanged(parsed.data, parsed.settings);
//       // setParsedJson(parsed);
//     }
//   }

//   return (
//     <div>
//       <textarea
//         value={formYaml}
//         onChange={textareaOnChanged}
//         className="fill"
//         rows="50"
//         style={{fontFamily: "Menlo, Monaco, 'Courier New', monospace"}}
//         />
//       <pre style={{fontFamily: "Menlo, Monaco, 'Courier New', monospace", fontSize: "small"}}>{JSON.stringify(parsedJson, null, 2)}</pre>
//     </div>
//   );
// }

// export default YamlEditor;

import { useState } from "react";
import yaml from "js-yaml";
import {
  UserStoryYaml,
  UserStory,
  UserStoryGroup,
  UserStoryGroupCollection,
} from "./UserStory2";
import Editor, { DiffEditor, useMonaco, loader } from "@monaco-editor/react";

export function YamlEditor({ value, onChanged }) {
  const parse = (text) => {
    try {
      return yaml.load(text);
    } catch (e) {
      console.error(e);
    }
  };

  const [formYaml, setFormYaml] = useState(value);
  const [parsedJson, setParsedJson] = useState(UserStoryYaml.fromYaml(value));

  // const textareaOnChanged = (e) => {
  //   try {
  //     setFormYaml(e.target.value);
  //     const { data, settings, isError } = UserStoryYaml.fromYaml(
  //       e.target.value
  //     );
  //     if (!isError) {
  //       console.log(isError);
  //       const boardData = new UserStoryGroupCollection(data, settings);
  //       onChanged(data, settings);
  //       setParsedJson(boardData);
  //     }
  //   } catch (e) {}
  // };

  const handleEditorOnChanged = (value) => {
    try {
      setFormYaml(value);
      const { data, settings, isError } = UserStoryYaml.fromYaml(value);
      if (!isError) {
        console.log(isError);
        const boardData = new UserStoryGroupCollection(data, settings);
        onChanged(data, settings);
        setParsedJson(boardData);
      }
    } catch (e) {}
  };

  const editorOptions = {
    minimap: {
      enabled: false,
    },
    lineNumbers: "off",
    stickyScroll: {
      defaultModel: "indentationModel",
      enabled: true,
      scrollWithEditor: false
    },
    guides: {
      indentation: false
    }
  };

  return (
    <div style={{position: "fixed"}}>
      <Editor
        height="100vh"
        width="450px"
        defaultLanguage="yaml"
        defaultValue={formYaml}
        onChange={handleEditorOnChanged}
        options={editorOptions}
      />
      {/* <textarea
        value={formYaml}
        onChange={textareaOnChanged}
        className="fill"
        rows="50"
        style={{
          fontFamily: "Menlo, Monaco, 'Courier New', monospace",
          width: "400px",
        }} 
      />*/}
      {/* <pre
        style={{
          fontFamily: "Menlo, Monaco, 'Courier New', monospace",
          fontSize: "small",
        }}
      >
        {JSON.stringify(parsedJson, null, 2)}
      </pre> */}
    </div>
  );
}

export default YamlEditor;
